import { useTranslation } from "react-i18next";
import { Video, Mic, Users, Podcast } from "lucide-react";

const features = [
  {
    key: "recording",
    icon: Video,
    colorClass: "bg-accent-yellow",
  },
  {
    key: "speech",
    icon: Mic,
    colorClass: "bg-accent-cyan",
  },
  {
    key: "meeting",
    icon: Users,
    colorClass: "bg-accent-pink",
  },
  {
    key: "podcast",
    icon: Podcast,
    colorClass: "bg-accent-blue",
  },
];

const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="heading-section text-center mb-12 md:mb-16">
          {t("features.title")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.key}
                className={`${feature.colorClass} rounded-2xl p-6 md:p-8 card-hover border-2 border-foreground`}
              >
                <div className="w-14 h-14 bg-background/20 rounded-full flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-foreground" />
                </div>
                <h3 className="heading-card mb-3">
                  {t(`features.${feature.key}.title`)}
                </h3>
                <p className="text-foreground/80">
                  {t(`features.${feature.key}.description`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
